import { useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { CustomerCartsController } from "./customer-carts-controller";
import { CustomerCartsPage } from "./customer-carts-page";

export function CustomerCartsRoute({ deps }: { deps: AppDeps }) {
  const [params] = useSearchParams();
  const focusCartId = params.get("cart");
  return (
    <Subtree
      key="customer-carts"
      deps={[focusCartId]}
      controller={() =>
        new CustomerCartsController(
          pick(
            deps,
            "client",
            "authHandler",
            "storeRepository",
            "providersRepository",
            "pendingCartsRepository",
            "stripeTerminal",
          ),
          focusCartId,
        )
      }
    >
      <CustomerCartsPage />
    </Subtree>
  );
}
